import { AppointmentPractitioner } from '@dreryk/egabinet-appointment-frontend-api';

import { createTranslatedText, FormContextValues } from '@dreryk/react-common';
import { Select } from '@dreryk/react-components';

import { appointmentsTranslationKeys } from '../../../../../../translations';

import { usePractitionerTriggerLabelExtractor } from './PractitionerSelect.hooks';
import { practitionerSelectFilter } from './PractitionerSelect.utils';

type PractitionerSelectProps = Pick<FormContextValues<{ practitioner: AppointmentPractitioner }>, 'register'> & {
   readonly practitioners: AppointmentPractitioner[];
};

export const PractitionerSelect = (props: PractitionerSelectProps): JSX.Element => {
   const triggerLabelExtractor = usePractitionerTriggerLabelExtractor();

   return (
      <Select<AppointmentPractitioner>
         label={appointmentsTranslationKeys.specialist}
         triggerLabelExtractor={triggerLabelExtractor}
         testId={'practitioner'}
         controller={props.register('practitioner', { required: true })}
         searchInputEnabled
      >
         <Select.Filter items={props.practitioners} filter={practitionerSelectFilter}>
            {({ filteredItems }) => (
               <Select.List items={filteredItems} keyExtractor={'id'}>
                  {(practitioner) => (
                     <Select.Item
                        key={practitioner.id.toString()}
                        item={practitioner}
                        testId={practitioner.id.toString()}
                        label={<Select.Highlight node={createTranslatedText(triggerLabelExtractor(practitioner))} />}
                     />
                  )}
               </Select.List>
            )}
         </Select.Filter>
      </Select>
   );
};
